import { IStringLocalizer } from "../../../utilities/IStringLocalizer";

export enum InventoryFileType {
    InventoryGeneralSupportingFile = "InventoryGeneralSupportingFile",
    InventoryQuestionnaireFile = "InventoryQuestionnaireFile",
    InventoryMetadataPageFile = "InventoryMetadataPageFile",
    InventoryPhotoFile = "InventoryPhotoFile",
    InventoryDeclareFile = "InventoryDeclareFile",
    InventoryMsdsFile = "InventoryMsdsFile",
    InventoryComplianceGeneralFile = "InventoryComplianceGeneralFile",
    InventoryScipFile = "InventoryScipFile",
    InventorySustainabilityFile = "InventorySustainabilityFile",
    InventoryCircularityFile = "InventoryCircularityFile",
    InventoryGeneralSupportingFileHpd = "InventoryGeneralSupportingFileHpd",
    InventoryGeneralSupportingFileC2c = "InventoryGeneralSupportingFileC2c",
    InventoryGeneralSupportingFileVoc = "InventoryGeneralSupportingFileVoc",
    InventoryGeneralSupportingFileOther = "InventoryGeneralSupportingFileOther",
    InventoryHniEdsImageFile = "InventoryHniEdsImageFile",
    InventorySoldItemFile = "InventorySoldItemFile",
    InventoryDynamicRegulationPageFile = "InventoryDynamicRegulationPageFile",
    InventoryTdsFile = "InventoryTdsFile",
    InventoryVocDataFile = "InventoryVocDataFile",
    InventoryInstructionsFile = "InventoryInstructionsFile",
    InventoryQuestionnaireCmrtFile = "InventoryQuestionnaireCmrtFile"
}

export enum FileType {
    GeneralFile = "GeneralFile",
    InventoryGeneralSupportingFile = "InventoryGeneralSupportingFile",
    InventoryQuestionnaireFile = "InventoryQuestionnaireFile",
    InventoryMetadataPageFile = "InventoryMetadataPageFile",
    InventoryPhotoFile = "InventoryPhotoFile",
    InventoryDeclareFile = "InventoryDeclareFile",
    InventoryMsdsFile = "InventoryMsdsFile",
    InventoryComplianceGeneralFile = "InventoryComplianceGeneralFile",
    InventoryScipFile = "InventoryScipFile",
    InventorySustainabilityFile = "InventorySustainabilityFile",
    InventoryCircularityFile = "InventoryCircularityFile",
    InventoryGeneralSupportingFileHpd = "InventoryGeneralSupportingFileHpd",
    InventoryGeneralSupportingFileC2c = "InventoryGeneralSupportingFileC2c",
    InventoryGeneralSupportingFileVoc = "InventoryGeneralSupportingFileVoc",
    InventoryGeneralSupportingFileOther = "InventoryGeneralSupportingFileOther",
    InventoryHniEdsImageFile = "InventoryHniEdsImageFile",
    InventorySoldItemFile = "InventorySoldItemFile",
    InventoryDynamicRegulationPageFile = "InventoryDynamicRegulationPageFile",
    InventoryTdsFile = "InventoryTdsFile",
    InventoryVocDataFile = "InventoryVocDataFile",
    InventoryInstructionsFile = "InventoryInstructionsFile",
    InventoryQuestionnaireCmrtFile = "InventoryQuestionnaireCmrtFile"
}

// WARNING. The order of these certification
// types in this enum must EXACTLY match the order
// of the Certification Enum in the backend.
export enum CertificationType {
    Other = "Other",
    C2c = "C2c",
    Declare = "Declare",
    Epd = "Epd",
    Hpd = "Hpd",
    Voc = "Voc",
    UlGreenGuard = "UlGreenGuard",
    UlGreenGuardGold = "UlGreenGuardGold",
    ScsIndoorAdvantage = "ScsIndoorAdvantage",
    ScsIndoorAdvantageGold = "ScsIndoorAdvantageGold",
    BimfaLevel = "BimfaLevel",
    EnergyStar = "EnergyStar",
    SaferChoice = "SaferChoice",
    Lpc = "Lpc",
    Nsf140 = "Nsf140",
    Nsf332 = "Nsf332",
    GreenCircleCertifiedEnvironmentalFacts = "GreenCircleCertifiedEnvironmentalFacts",
    GreenCircleCertifiedSustainabilityFacts = "GreenCircleCertifiedSustainabilityFacts",
    UlEcologo = "UlEcologo",
    AnsiNsc373 = "AnsiNsc373",
    UlProductLens = "UlProductLens",
    GreenCircleCertifiedManufacturerInventoryVerification = "GreenCircleCertifiedManufacturerInventoryVerification",
    C2cMaterialHealth = "C2cMaterialHealth",
    Greenscreen = "Greenscreen",
    GreenHealthApproved = "GreenHealthApproved",
    GreenSeal = "GreenSeal",
    CdphStandardMethodv122017 = "CdphStandardMethodv122017",
    Floorscore = "Floorscore",
    CriGreenLabelPlus = "CriGreenLabelPlus",
    MasCertifiedGreen = "MasCertifiedGreen",
    IntertekCleanAir = "IntertekCleanAir",
    TscaTitleViNaf = "TscaTitleViNaf",
    TscaTitleViUlef = "TscaTitleViUlef",
    Lca = "Lca",
    GreenCircleCertifiedLifeCycleAssessmentOptimized = "GreenCircleCertifiedLifeCycleAssessmentOptimized",
    ScsCarbonNeutral = "ScsCarbonNeutral",
    GreenCircleCertifiedEnergySavings = "GreenCircleCertifiedEnergySavings",
    FcsCertified = "FcsCertified",
    SfiCertified = "SfiCertified",
    UsdaCertifiedBiobased = "UsdaCertifiedBiobased",
    GreenCircleCertifiedBiobasedContent = "GreenCircleCertifiedBiobasedContent",
    UlEnvironmentalClaimValidationBiobasedContent = "UlEnvironmentalClaimValidationBiobasedContent",
    GreenCircleCertifiedRecycledContent = "GreenCircleCertifiedRecycledContent",
    UlEnvironmentalClaimValidationRecycledContent = "UlEnvironmentalClaimValidationRecycledContent",
    ScsRecycledContentCertified = "ScsRecycledContentCertified",
    GlobalRecycledStandard = "GlobalRecycledStandard",
    GreenCircleCertifiedClosedLoopProduct = "GreenCircleCertifiedClosedLoopProduct",
    GreenCircleCertifiedRecyclableMaterial = "GreenCircleCertifiedRecyclableMaterial",
    UsEpdWaterSense = "UsEpdWaterSense"
}

export enum FileMetadataType {
    PlainDocument = 0,
    Certification
}

export interface BaseDocumentMetadata {
    description: string;
}

export interface PlainDocumentMetadata extends BaseDocumentMetadata {

}

export interface CertificationDocumentMetadata extends BaseDocumentMetadata {
    type?: CertificationType;
    otherTypeValue: string;
    level: string;
    expirationDate: string; // ISO8601 timestamp
}

export type FileMetadata = PlainDocumentMetadata | CertificationDocumentMetadata;

//
// Represents a file that the user has uploaded to a summary page
//
export interface FileTableEntry {
    fileId: string;
    inventoryId?: string;
    type: FileType;
    filename: string;
    metadataType: FileMetadataType | string;
    metadata: FileMetadata;
    metadataJson?: string;
}

export interface FileTypeDetails {
    value: FileMetadataType;
    displayValue: string;
}